module.exports = function(callback){

	return {
		check: function(callback){
			$.ajax(urlPrefix + '/api/user/login/status', {
				type: 'GET',
				dataType: 'json'
			})
			.done(function(result){
				if(result.status === 0){
                    if($('#user-welcome').length === 0){
                        var user_welcome$ = $('<h5>').attr('id', 'user-welcome').append($('<i>').addClass('fa fa-user')).append('您好, ' + result.userInfo.name + ' 歡迎回來');
                        var hr$ = $('<hr>').addClass('margin-top-20 margin-bottom-10');
                        $('.menu-container').eq(1).prepend(hr$).prepend(user_welcome$);
                    }
					callback(null, true, result.userInfo);
				}
				else{
					callback(null, false);
				}
			})
			.fail(function(error){
				callback(error);
			});
		},

		initModal: function(triggerButton, nextHandle, denyNonMember){
		    var that = this;
		    var denyNonMember = denyNonMember || !enableNonMember;
            var loginModal$ = $('#loginModal');
            if (denyNonMember !== true) {
                $('#non-member-booking').show();
            } else {
                $('#non-member-booking').hide();
            }
            loginModal$.modal();
            loginModal$.on('shown.bs.modal', function(){
                var that$ = $(this);
                var text1= require('../../../../public/locales/'+locale+'/hotel.json');
                loginModal$.on('click', '#login-modal-submit', function(){
                    var username = $('#login-username').val();
                    var password = $('#login-password').val();
                    var veteran = $('#login-veteran').val(); //榮民訂房會員登入用
                    var remember$ = $('#login-remember');
                    var remember = 'N';
                    if(remember$.prop('checked')){
                        remember = 'Y';
                    }
                    that$.attr('disabled', true);
                    $.ajax(urlPrefix + '/api/user/login', {
                        type: 'POST',
                        dataType: 'json',
                        headers: {
                            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr('content')
                        },
                        data: {
                            username: username,
                            password: password,
                            remember: remember,
                            veteran: veteran
                        }
                    })
                    .done(function(result){
                        if(result.status === 0){
                            var message$ = $('<div>').addClass('alert alert-success').text(text1.SystemText.LoginSuccessful);
                            $('#login-modal-message').html(message$);
                            var logout$ = $('<a>', {
                                'href': urlPrefix + '/user/logout'
                            }).append($('<i>').addClass('fa fa-user')).append(text1.SystemText.MemberLogout);
                            $('#member-login-logout').html(logout$);
                            setTimeout(function(){
                                loginModal$.modal('hide');
                                that.check(function(err, status, userInfo) {
                                    if (status === true) {
                                        nextHandle(triggerButton, userInfo);
                                    } else {
                                        alert(text1.SystemText.LoginTimeout);
                                    }
                                });
                            }, 1000);
                        }
                        else{
                            var message = result.message || text1.SystemText.PasswordIncorrect;
                            var message$ = $('<div>').addClass('alert alert-danger').text(message);
                            $('#login-modal-message').html(message$);
                            that$.attr('disabled', false);
                        }
                    })
                    .fail(function(error){
                        if(error.status === 422){
                            var message$ = $('<div>').addClass('alert alert-danger').text(text1.SystemText.DataIncorrect);
                            $('#login-modal-message').html(message$);
                        }
                        if(error.status === 500){
                            var message$ = $('<div>').addClass('alert alert-danger').text(text1.SystemText.ServerError);
                            $('#login-modal-message').html(message$);
                        }
                    });
                });
            });

            loginModal$.on('click', '#non-member-booking', function(){
                loginModal$.modal('hide');

                nextHandle(triggerButton);
            });

            loginModal$.on('hidden.bs.modal', function(event){
                $('#login-modal-message > div').remove();
                loginModal$.off('click', '#login-modal-submit');
                loginModal$.off('click', '#non-member-booking');
            });
		}
	};

}();


// WEBPACK FOOTER //
// ./assets/custom/js/user/login.js